import React from 'react'

function NonGreenComment() {
  return (
    <div>NonGreenComment</div>
  )
}

export default NonGreenComment